import { render } from "./EditAdminSettings.vue?vue&type=template&id=db67ea3c"
import script from "./EditAdminSettings.vue?vue&type=script&lang=js"
export * from "./EditAdminSettings.vue?vue&type=script&lang=js"

import "./EditAdminSettings.vue?vue&type=style&index=0&id=db67ea3c&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__